import React from 'react'
import { useTranslation } from 'react-i18next'
import CardSummaryWithLoading from '../ui/card/CardSummaryWithLoading'
import RatingBox from '../ui/RatingBox'

const DashboradNavBar = ({
    servicesLoading,
    serviceLength,
    ratingLoading,
    ratingLength,
    completedComplaintsCount,
    incompleteComplaintsCount,
    servicesRate,
    employeesRate
}) => {
    const [t] = useTranslation('global')
    return (
        <div className='flex flex-col gap-6 py-6'>
            <div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6'>
                <CardSummaryWithLoading
                    label={t('dashboard.servicesCount')}
                    loading={servicesLoading}
                    data={serviceLength}
                    icon='/assets/icons/icons8-service-100.png'
                    className="bg-white hover:border-indigo-200 shadow-sm hover:shadow-md border border-slate-100 transition-all duration-300"
                />
                <CardSummaryWithLoading
                    label={t('dashboard.ratingsCount')}
                    loading={ratingLoading}
                    data={ratingLength}
                    icon='/assets/icons/icons8-rating-96.png'
                    className="bg-white hover:border-indigo-200 shadow-sm hover:shadow-md border border-slate-100 transition-all duration-300"
                />
                <CardSummaryWithLoading
                    label={t('dashboard.completedComplaints')}
                    loading={ratingLoading}
                    data={completedComplaintsCount}
                    icon='/assets/icons/icons8-rating-96.png'
                    className="bg-emerald-50/50 hover:bg-emerald-50 border border-emerald-100 hover:border-emerald-200 shadow-sm hover:shadow-md transition-all duration-300"
                />
                <CardSummaryWithLoading
                    label={t('dashboard.incompleteComplaints')}
                    loading={ratingLoading}
                    data={incompleteComplaintsCount}
                    icon='/assets/icons/icons8-rating-96.png'
                    className="bg-rose-50/50 hover:bg-rose-50 border border-rose-100 hover:border-rose-200 shadow-sm hover:shadow-md transition-all duration-300"
                />
            </div>

            <div className='grid grid-cols-1 md:grid-cols-2 gap-6'>
                <CardSummaryWithLoading
                    reverse={true}
                    label={t('dashboard.totalRatingsServices')}
                    className="bg-gradient-to-br from-amber-50 to-orange-50/50 border border-amber-100 hover:border-amber-200 shadow-sm hover:shadow-md transition-all duration-300"
                >
                    <RatingBox size={32} rate={servicesRate} />
                </CardSummaryWithLoading>

                <CardSummaryWithLoading
                    reverse={true}
                    label={t('dashboard.totalRatingsEmployees')}
                    className="bg-gradient-to-br from-blue-50 to-indigo-50/50 border border-blue-100 hover:border-blue-200 shadow-sm hover:shadow-md transition-all duration-300"
                >
                    <RatingBox size={32} rate={employeesRate} />
                </CardSummaryWithLoading>
            </div>
        </div>
    )
}

export default DashboradNavBar
